import {
  servicesCardsTextsExperimentGroups,
  servicesCardsTextsExperimentName,
  TServicesCardsTextsExperimentGroupsNames,
} from './servicesCardsTextsExperiment';
import {
  competitionExperimentGroups,
  competitionExperimentName,
  TCompetitionExperimentGroupsNames,
} from './competitionExperiment';

export const allExperiments = {
  [servicesCardsTextsExperimentName]: servicesCardsTextsExperimentGroups,
  [competitionExperimentName]: competitionExperimentGroups,
};
export type TExperimentsGroups = TServicesCardsTextsExperimentGroupsNames | TCompetitionExperimentGroupsNames;
export type TExperiments = typeof allExperiments;
export type TExperimentsNames = keyof typeof allExperiments;
